<script context='module'>
  import { append } from 'ramda';
  import { getContext } from 'svelte';
  import { writable, get } from 'svelte/store';

  const MODALS = Symbol('Modals');

  class Entry {
    constructor(context, element, dispatch, {
      size, position, fullscreen, transparent,
    }) {
      this.context = context;
      this.element = element;
      this.dispatch = dispatch;
      this.size = size;
      this.position = position;
      this.fullscreen = fullscreen;
      this.transparent = transparent;
    }

    show() {
      if (this.context === undefined) {
        throw new Error('ModalRoot context is undefined. Did you forget to wrap the Modal in a ModalRoot?');
      }

      this.context.update(append(this));
    }

    dismiss(value) {
      const modals = get(this.context);
      if (modals.includes(this)) {
        this.context.set(modals.filter((entry) => entry !== this));
        this.dispatch('dismiss', value);
      }
    }
  }

  export const useModals = () => {
    const modals = getContext(MODALS);
    return (...args) => new Entry(modals, ...args);
  };
</script>

<script>
  import ModalContainer from './ModalContainer.svelte';
  import Provider from '../Provider';

  const modals = writable([]);
</script>

<Provider key={MODALS} value={modals}>
  <slot />

  {#each $modals as modal (modal)}
    <ModalContainer {modal} />
  {/each}
</Provider>
